"use strict";

angular.module('PatientApp').directive('acceptedCards', function () {
  return {
    scope: false,
    link: function link() {},
    template: '<img id="amex" version-src="assets/images/amex_logo_v2.svg"/>' + '<img id="mastercard" version-src="assets/images/mastercard_logo_v2.svg"/>' + '<img id="visa" version-src="assets/images/visa_logo_v2.svg"/>' + '<img id="discover" version-src="assets/images/discover_logo_v2.svg"/>'
  };
});